import { Component, Input } from '@angular/core';
import { IAdminModalComponent, IAdminModalData } from '../../domain/models/admin-modal';

@Component({
	selector: 'app-admin-raw-json-modal',
	templateUrl: './admin-raw-json-modal.component.html',
	styleUrls: ['./admin-raw-json-modal.component.scss']
})
export class AdminRawJsonModalComponent implements IAdminModalComponent {
	@Input() data: IAdminModalData<{}>;

	constructor() {
	}

	closeEvent(e?: {}): void {
	}

}
